import React from "react";
import { NavLink } from "react-router-dom";
import style from "./TabButton.module.css";

export interface ButtonProps {
  title: string;
  to: string;
  icon: React.ReactNode; //SVG
  disabled: boolean;
}

const TabButton = ({ title, to, icon, disabled }: ButtonProps) => (
  <NavLink
    to={to}
    activeStyle={{ opacity: 1 }}
    style={{ opacity: 0.4, pointerEvents: disabled ? "none" : "all" }}
  >
    <button className={style.button} disabled={disabled}>
      {icon}
      {title}
    </button>
  </NavLink>
);

export default TabButton;
